var map = {
	"./views/College/index": [
		"7cc6",
		"chunk-2c2457c7"
	],
	"./views/Home/index": [
		"16c0",
		"chunk-69d0128d"
	],
	"./views/ImgUpload/index": [
		"9f1c",
		"chunk-56f130b0"
	],
	"./views/OrderManage/index": [
		"6053",
		"chunk-3a2c8922"
	],
	"./views/ShopAssistantList/index": [
		"8e22",
		"chunk-5cb03741"
	],
	"./views/redirect/index": [
		"ef3c",
		"chunk-a45b9ce0"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3ab3";
module.exports = webpackAsyncContext;